<template>
  <div class="items-end ">
    <v-card shaped elevation="10" class="p-3 ">
      <div class="flex justify-center w-full" v-if="loading">
        <Lynx-Spinner size="12" />
      </div>
      <div v-else>
        <div class="flex absolute right-0">
          <p class="pr-3">%</p>
          <b-switch v-model="isValor" outlined> Qtd </b-switch>
        </div>
        <h2 class="text-lg md:text-base text-neutral-600">
          {{ header.title }}
        </h2>

        <div id="chart">
          <apexchart
            type="radialBar"
            height="300"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import PieChart from "@/components/Chart/PieChart";
import { twColors, twFonts } from "@/services/tailwindConfig";
import NotFoundData from "@/components/layouts/NotFoundData";
import { irpfStatsRequest } from "@/services/requests/charts";

export default {
  name: "ResumoIRPF",
  components: { PieChart, NotFoundData },
  data() {
    return {
      header: {
        title: "Resumo IRPF " + (new Date().getFullYear() - 1),
      },
      loading: true,
      values: {},
      loadingChart: true,
      notFoundData: false,
      isValor: true,
      notFoundMessage: "",
    };
  },
  computed: {
    chartOptions() {
      let data = {
        chart: {
              height: 300,
              type: 'radialBar',
            },
            plotOptions: {
              radialBar: {
                offsetY: 10,
                offsetX: 50,

                startAngle: 0,
                endAngle: 270,
                hollow: {
                  margin: 5,
                  size: '10%',
                  background: 'transparent',
                  image: undefined,
                },
                dataLabels: {
                  name: {
                    show: false,
                  },
                  value: {
                    show: false,
                  }
                }
              }
            },
        colors: [
          twColors.neutral[900],

          twColors.error.dark,
          twColors.primary[400],
          twColors.primary[600],
          twColors.warning.base,
          twColors.success.base,
        ],
        labels: [
          "Cancelados",
          "Não responderam",
          "Responderam questionario",
          "Iniciou envio de pendências",
          "Pendências enviadas",
          "Finalizados",
        ],
        fill: {
          type: "gradient",
        },
        legend: {
          show: true,
          floating: true,
          fontSize: "13px",
          position: "left",
          offsetX: 0,
          offsetY: 0,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0,
          },
        
          itemMargin: {
            vertical: 1,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
              },
            },
          },
        ],
      };
      if (this.isValor) {
        let sum = this.total;

        data.legend.formatter = function (seriesName, opts) {
                    return seriesName + ":  " + Math.round(opts.w.globals.series[opts.seriesIndex] * (sum) / 100) ;
        };
        return data;
      } else {
        data.legend.formatter = function (seriesName, opts) {
          return (
            seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
          );
        };
        return data;
      }
    },
    series() {
      return [
        this.formatter(this.values.cancelados),
        this.formatter(this.values.nao_responderam),
        this.formatter(this.values.responderam),
        this.formatter(this.values.iniciou_pendencias),
        this.formatter(this.values.enviou_pendencias),
        this.formatter(this.values.finalizou),
      ];
    },

    total() {
      let dataArr = [
        this.values.cancelados,
        this.values.nao_responderam,
        this.values.responderam,
        this.values.iniciou_pendencias,
        this.values.enviou_pendencias,
        this.values.finalizou,
      ];
      let sum = 0;

      for (var i = 0; i < dataArr.length; i++) {
        sum += parseInt(dataArr[i]);
      }
      return sum;
    },
  },
  methods: {
    fetchValues() {
      irpfStatsRequest()
        .then((res) => (this.values = res.data))
        .finally(() => (this.loading = false));
    },
    formatter(value) {
      console.log(this.total);
      return ((value * 100) / this.total).toFixed(2);
    },
  },
  mounted() {
    this.fetchValues();
  },
};
</script>
